import  { useEffect, useRef } from 'react';


export const useTimedUserInput = ( { time = 500, onTimeout, onChange } ) => {
    const timerRef = useRef();

    function handleTextChange() {
        onChange?.();
        clearTimeout( timerRef.current );
        timerRef.current = setTimeout( () => onTimeout?.(), time );
    }

    useEffect( () => {
        return () => {
            clearTimeout( timerRef.current );
        };
    }, [] );

    return { handleTextChange };
};